import { getTranslationNamespace } from '../../helpers/getTranslationNamespace'

const TRANSLATION_NAMESPACE = getTranslationNamespace('-header')

// JBP Planning Wizard
export const TRANSLATION_KEYS = {
  wizardTitle: `${TRANSLATION_NAMESPACE}--title`, // {PartnerName}
  wizardSubTitle: `${TRANSLATION_NAMESPACE}--subtitle`, // {PartnerID} - FY{CurFYear} Plan
  isHideWizard: `${TRANSLATION_NAMESPACE}--hide-wizard`, // Hide this wizard in the future
  editButton: `${TRANSLATION_NAMESPACE}--edit`, // Edit
  saveButton: `${TRANSLATION_NAMESPACE}--save`, // Save
  discardButton: `${TRANSLATION_NAMESPACE}--discard`, // Discard
  closeButton: `${TRANSLATION_NAMESPACE}--close`, // Close
}
